import { Link } from 'react-router-dom'
import {MapPin, ArrowRight, Phone, Calendar} from 'lucide-react'
import SectionHeader from '@/components/SectionHeader'

const cantons = [
  {
    name: 'Genève',
    cities: [
      { city: 'Genève', slug: 'geneve' },
      { city: 'Carouge', slug: 'carouge' },
      { city: 'Vernier', slug: 'vernier' },
      { city: 'Meyrin', slug: 'meyrin' },
    ],
  },
  {
    name: 'Vaud',
    cities: [
      { city: 'Lausanne', slug: 'lausanne' },
      { city: 'Montreux', slug: 'montreux' },
      { city: 'Vevey', slug: 'vevey' },
      { city: 'Nyon', slug: 'nyon' },
      { city: 'Morges', slug: 'morges' },
      { city: 'Yverdon-les-Bains', slug: 'yverdon' },
    ],
  },
  {
    name: 'Neuchâtel',
    cities: [
      { city: 'Neuchâtel', slug: 'neuchatel' },
      { city: 'La Chaux-de-Fonds', slug: 'chaux-de-fonds' },
    ],
  },
  {
    name: 'Fribourg',
    cities: [
      { city: 'Fribourg', slug: 'fribourg' },
      { city: 'Bulle', slug: 'bulle' },
    ],
  },
  {
    name: 'Valais',
    cities: [
      { city: 'Sion', slug: 'sion' },
      { city: 'Martigny', slug: 'martigny' },
      { city: 'Monthey', slug: 'monthey' },
    ],
  },
]

export default function ZonesPage() {
  return (
    <div>
      <section className="py-14 lg:py-20 bg-navy-50">
        <div className="max-w-5xl mx-auto px-5 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-navy-200 text-navy-600 text-xs font-bold uppercase tracking-wider">
            Couverture Suisse romande
          </div>
          <h1 className="mt-5 text-4xl lg:text-5xl font-extrabold text-navy-700 tracking-tight leading-[1.05] text-balance">
            Plombier d'urgence dans toute la Suisse romande
          </h1>
          <p className="mt-5 text-lg text-navy-500 leading-relaxed max-w-3xl mx-auto">
            Notre équipe intervient rapidement dans les principaux cantons et villes de Suisse romande, 24h/24 et 7j/7.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 space-y-12">
          {cantons.map((canton) => (
            <div key={canton.name}>
              <div className="flex items-end justify-between mb-5">
                <h2 className="text-2xl lg:text-3xl font-extrabold text-navy-700">Canton de {canton.name}</h2>
                <div className="text-sm font-bold text-urgent-600">{canton.cities.length} villes</div>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
                {canton.cities.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/zones/${c.slug}`}
                    className="group flex items-center gap-3 px-5 py-4 rounded-xl bg-white border border-navy-100 hover:border-urgent-300 hover:bg-urgent-50/40 transition-all"
                  >
                    <MapPin className="w-5 h-5 text-urgent-500 flex-shrink-0" strokeWidth={2.2} />
                    <div className="flex-1 min-w-0">
                      <div className="font-bold text-navy-700 text-sm">Plombier {c.city}</div>
                      <div className="text-[11px] text-navy-400 font-semibold">Urgence 24/7</div>
                    </div>
                    <ArrowRight className="w-4 h-4 text-navy-400 group-hover:text-urgent-500 group-hover:translate-x-0.5 transition-all" />
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 lg:py-20 gradient-trust text-white">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
          <SectionHeader
            eyebrow="Votre ville n'apparaît pas ?"
            title="Nous nous déplaçons partout en Suisse romande"
            subtitle="Contactez-nous, nous trouverons une solution rapide pour votre intervention."
          />
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <a href="tel:+41796430399" className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl gradient-urgent text-white font-bold shadow-orange-glow">
              <Phone className="w-5 h-5" strokeWidth={2.5} />
              079 643 03 99
            </a>
            <a href="https://fixnow.ch" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl bg-white text-navy-700 font-bold hover:bg-navy-50 transition-colors">
              <Calendar className="w-5 h-5" strokeWidth={2.5} />
              Voir notre disponibilité sur FixNow
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}
